import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "./index.css";
import { DEV_BYPASS_AUTH, initMsal, msalInstance } from "./lib/auth";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

function renderApp() {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>,
  );
}

if (DEV_BYPASS_AUTH) {
  console.warn("⚠️ DEV_BYPASS_AUTH activo — MSAL deshabilitado. NO usar en prod.");
  // MsalProvider necesita una instancia inicializada (los hooks la leen),
  // pero no hacemos login: la app salta directo via DEV_BYPASS_AUTH en App.tsx.
  msalInstance.initialize().then(renderApp);
} else {
  initMsal().then(renderApp);
}
